import script from "./AddDecisionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddDecisionModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddDecisionModal.vue?vue&type=style&index=0&id=17414118&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17414118"]])

export default __exports__